// Cart drawer "You may also like" — fetches the cart-recommendations section
// via the Section Rendering API and injects the items into the drawer.
(function () {
  function loadCartRecs() {
    var container = document.getElementById('cart-recs');
    if (!container) return;

    var list = container.querySelector('[data-cart-recs-list]');
    var recsUrl = container.getAttribute('data-recs-url');
    var productId = container.getAttribute('data-product-id');

    if (!list || !recsUrl || !productId) {
      container.style.display = 'none';
      return;
    }

    var url =
      recsUrl +
      (recsUrl.indexOf('?') > -1 ? '&' : '?') +
      'section_id=cart-recommendations&product_id=' +
      encodeURIComponent(productId) +
      '&limit=4';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Cart recommendations request failed');
        return response.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('[data-cart-rec-item]');

        if (!items.length) {
          container.style.display = 'none';
          list.innerHTML = '';
          return;
        }

        list.innerHTML = '';
        items.forEach(function (item) {
          list.appendChild(item);
        });
        container.style.display = '';
      })
      .catch(function () {
        container.style.display = 'none';
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCartRecs);
  } else {
    loadCartRecs();
  }

  // The ajax-cart library re-renders the whole `main` region (including
  // #cart-recs and its data-product-id) after every cart change, so re-fetch
  // each time to stay in sync with the current last-added product.
  document.addEventListener('liquid-ajax-cart:request-end', loadCartRecs);
})();
